<template>
  <!-- 支付弹窗 -->
  <div class='publicPay'>
    <div class="payDialog" v-if="payDialogShow">
      <!-- 标题+关闭按钮 -->
      <div class="titles">
        <div class="title">选择支付方式</div>
        <div class="icon_close" @click="handleClose"></div>
      </div>
      <!-- 支付信息 -->
      <div class="payInfo">
        <div class="payPrice"><span v-if="!isBobi">￥</span>{{isBobi?bobi:payPrice}}<span class="bobi" v-if="isBobi">播币</span></div>
        <div class="payName">{{payName}}</div>
      </div>
      <!-- 支付方式 -->
      <div class="payType">
        <div class="typeItem" v-for="(item,index) in payTypeList" :key="index" @click="changeSelect(index,item.pt)" :class="{itemNoBor:payTypeList.length===1}">
          <div class="type">
            <div class="icons"> <img :src="item.icon" alt=""></div> {{item.name}}
          </div>
          <div class="select" :class="{selected:selectIndex===index}">

          </div>
        </div>
      </div>
      <!-- 支付按钮 -->
      <div class="payBtn" @click="gotoPay(selectedPt)">
        确认支付
      </div>
    </div>
    <!-- loading -->
    <div class="loading" v-if="isLoading">
      <img src="https://images.zhibo.tv/2021/0308/icon_loading@10x.png" alt="">
    </div>
    <!-- 提示弹框 -->
    <publicDialog :info="info" :title="title" :btn1="btn1" :btn2="btn2" @changeShow='showDialog' :dialogIsShow='dialogIsShow' v-show='dialogIsShow' @closeRenew="closeRenew(userInfo.vipType)" :height='height'
      :paySuccess='paySuccess' @getAutoStatus="getAutoStatus">
    </publicDialog>

  </div>
</template>

<script>
import publicDialog from '../components/PublicDialog'
export default {
  components: { publicDialog },
  props: ['payName', "payPrice", 'payType', "isShowDialog", "cardId", 'priceId'],
  data () {
    return {
      //  @touchmove.stop.prevent,最外层需要加此事件，但是优惠券有bug暂时去掉
      isShow: this.isShowDialog,
      // dialog的提示内容
      dialogIsShow: false,
      info: '',
      title: "提示",
      btn1: "",
      btn2: '我知道了',
      //是否购买成功
      status: 1,// 成功，失败，重复购买
      successInfo: '您已购买巅峰赛事包名称成功',
      bagType: 2,
      isBobi: false,
      paySuccess: false,
      token: '',
      canbuy: true,
      height: '',
      payTypeList: [],
      selectIndex: 0,
      selectedPt: 5,
      code: '',
      autoTimer1: '',
      autoTimer2: '',
      isLoading: false,
      autopayStatus: '',
      payDialogShow: true
      // bobi:''
    }
  },
  watch: {
    isShow (val) {
      this.isShowDialog = val;
    },
    payType (val) {
      console.log(val);
      this.selectIndex = 0
      this.selectedPt = val[0]
      this.isBobi = false
      if (val.length > 1) {
        this.payTypeList = [{ name: '微信支付', icon: 'https://images.zhibo.tv/2020/1109/icon_wxpay@2x.png', pt: 5 }, { name: '支付宝', icon: 'https://images.zhibo.tv/2020/1109/icon_alipay@2x.png', pt: 6 }, { name: '播币', icon: 'https://images.zhibo.tv/2020/1109/icon_bobi@2x.png', pt: 2 }]
      } else {

        this.payTypeList = [{ name: '微信支付', icon: 'https://images.zhibo.tv/2020/1109/icon_wxpay@2x.png', pt: 5 }]
      }
    }
  },
  created () {
    this.getToken()
    if (this.payPrice) {
      this.bobi = this.payPrice * 100
    }
  },
  mounted () {
    window.VIP_CENTER = {
      paySucc: () => {
        this.btn1 = ""
        this.btn2 = '我知道了'
        this.info = "您已成功购买会员"
        this.paySuccess = true
        this.showDialog(true)
      }
    }
  },
  methods: {
    // 修改选中的支付方式
    changeSelect (index, pt) {
      this.selectIndex = index
      this.selectedPt = pt
      if (pt === 2) {
        this.isBobi = true
      } else {
        this.isBobi = false
      }
    },
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
    },
    // 限制购买
    limitPay () {
      this.timer = setTimeout(() => {
        this.canbuy = true
      }, 2000);
    },
    // 安卓支付
    gotoPay (pt) {
      console.log('click', this.canbuy);
      console.log(this.payType.length);
      if (this.canbuy) {
        this.canbuy = false
        this.limitPay()
        if (this.payType.length === 1) {
          // alert('安卓购买连续包月')
          // 连续包月
          this.androidAutoPay(pt)
        } else {
          //普通会员
          // alert('安卓购买普通会员')
          this.androidCommonPay(pt)
        }
      } else {
        this.info = "操作频繁，请稍后!"
        this.btn1 = "",
          this.btn2 = '我知道了',
          this.showDialog(true)
      }

    },
    // 安卓普通会员支付
    androidCommonPay (pt) {
      console.log(pt);
      if (pt === 2) {
        this.isBobi = true
      } else {
        this.isBobi = false
      }
      let params = `token=${this.token}&cardId=${this.cardId}&priceId=${this.priceId}&payType=${pt}&bagType=${this.bagType}&statistics=${this.$CONFIG.statistics}`
      this.$vipapi.AndroidPay(params).then(res => {
        console.log(res)
        // alert(window.LiveAppJS.buyVip)
        if (pt !== 2) {
          // 拉起安卓app支付
          try {
            // alert(window.LiveAppJS.buyVip)
            window.LiveAppJS.buyVip(res.data.data, this.cardId);
          } catch (error) {
            console.log(error, res.data.data, this.cardId);
          }
        }
        // 播币成功支付
        if (res.data.data === 'success') {
          this.info = "您已成功购买会员"
          this.paySuccess = true
          this.showDialog(true)
          // let androidPrams = '{"payType:3"}';
          // 通知安卓播币购买成功
          try {
            // alert(window.LiveAppJS.buyVip)
            let jsonstr = '{"vipId":"' + this.cardId + '"}'
            window.LiveAppJS.buyVipSuccess(jsonstr);
          } catch (error) {
            console.log('未成功通知安卓播币购买成功', error, '{"vipId":"' + this.cardId + '"}');
          }
          // setTimeout(() => {
          //   this.$emit('changePayShow', false);
          // }, 2000);
        }
        // 播币不足
        if (res.data.status === '902') {
          // this.info = "播币不足，是否去充值"
          // this.btn1 = "取消",
          //   this.btn2 = '去充值',
          //   this.showDialog(true)
          //充值
          try {
            window.webkit.messageHandlers.recharge.postMessage('recharge');
          } catch (e) { console.log('error') }
          try {
            window.LiveAppJS.recharge();
          } catch (e) { console.log('error') }
        }
        // 内部服务器错误500 购买时长超限802
        if (res.data.status === '500' || res.data.status === 802) {
          this.info = res.data.data

          this.btn1 = "",
            this.btn2 = '我知道了',
            this.showDialog(true)
        }
      })
    },
    // 安卓连续包月会员支付
    async androidAutoPay () {
      let params = `token=${this.token}&pId=${this.priceId}&bt=${this.bagType}&pt=5&vId=${this.cardId}&statistics=${this.$CONFIG.statistics}`
      let res = await this.$vipapi.openAndroidAuto(params)
      console.log(res);
      console.log(res);
      this.code = JSON.parse(res.data.data).contract_code
      if (res.data.status === "200") {
        if (res.data.addition === 2) {
          console.log("拉起安卓app支付连续包月签约");
          // 拉起安卓app支付连续包月签约
          try {
            window.LiveAppJS.wxEntrustInfo(res.data.data);
          } catch (error) {
            console.log(error);
          }
        } else {
          console.log("拉起安卓app支付连续包月");
          // 拉起安卓app支付
          try {
            // alert(window.LiveAppJS.buyVip)
            window.LiveAppJS.buyVip(res.data.data, 'V3');
          } catch (error) {
            console.log(error);
          }
        }
      }

      // 内部服务器错误
      if (res.data.status === '-1') {
        this.info = res.data.data

        this.btn1 = "",
          this.btn2 = '我知道了',
          this.showDialog(true)
      } else {
        this.height = '4.16rem'
        this.info = '请确认支付是否已完成，如果在支付过程中遇到问题请点击"重新支付"，如果已经成功支付请点击"已支付"'
        this.btn1 = "重新支付"
        this.btn2 = '已支付'
        setTimeout(() => {
          this.showDialog(true)
        }, 1000);
      }
    },
    getAutoStatus () {
      this.isLoading = true
      this.payDialogShow = false
      this.autoTimer1 = setInterval(() => {
        this.getStatusByInterface()
      }, 1000);
      this.autoTimer2 = setTimeout(() => {
        clearInterval(this.autoTimer1)
        this.isLoading = false

        // 未签约未支付
        if (this.autopayStatus === 0) {
          console.log('未支付');
          clearInterval(this.autoTimer1)
          this.isLoading = false
          this.height = '4rem'
          this.info = `暂未查询到您的支付结果，可能是会员延时到账，如有疑问，请联系客服，客服电话：400-801-5553`
          this.btn1 = ""
          this.btn2 = '我知道了'
          this.showDialog(true)
        }
        // 已签约未支付
        if (this.autopayStatus === 1) {
          console.log('已签约未支付');
          clearInterval(this.autoTimer1)
          this.isLoading = false
          this.height = '4rem'
          this.info = `暂未查询到您的支付结果，可能是会员延时到账，如有疑问，请联系客服，客服电话：400-801-5553`
          this.btn1 = ""
          this.btn2 = '我知道了'
          this.showDialog(true)
        }
      }, 5000);
      // // 支付失败
      // if (this.autopayStatus===0) {
      //   console.log('支付失败');
      //   this.height = '3.32rem'
      //   this.info = '您已开通连续包月失败'
      //   this.btn1 = ""
      //   this.btn2 = '我知道了'
      //   this.showDialog(true)
      // }
      // // 支付中
      // if (this.autopayStatus===1) {
      //   console.log('支付中');
      //   this.height = '3.32rem'
      //   this.info = '支付中,请稍后...'
      //   this.btn1 = ""
      //   this.btn2 = '我知道了'
      //   this.showDialog(true)
      // }
      // // 支付成功
      // if (this.autopayStatus===2) {
      //   console.log('支付成功');
      //   clearInterval(this.autoTimer)
      //   this.height = '3.32rem'
      //   this.info = '您已开通连续包月成功'
      //   this.btn1 = ""
      //   this.btn2 = '我知道了'
      //   this.showDialog(true)
      // }
    },
    async getStatusByInterface () {
      let params = {
        token: this.token,
        contractCode: this.code
      }
      let res = await this.$vipapi.getAutoStatus(params)
      this.autopayStatus = Number(res.data.data.payState)

      console.log(this.autopayStatus);
      // 支付成功
      if (this.autopayStatus === 2) {
        let nextTime = res.data.data.nextFeeTime
        console.log('支付成功');
        clearInterval(this.autoTimer1)
        this.isLoading = false
        this.height = '4rem'
        this.info = `您已开通${this.payName}连续包月，下次扣费时间为：${nextTime}，扣费后会员有效期将延长30天!`
        this.btn1 = ""
        this.btn2 = '我知道了'
        this.showDialog(true)
      }
    },
    handleClose () {
      clearTimeout(this.timer);
      this.canbuy = true
      // this.isBobi = false
      this.$emit('changePayShow', false);
    },
    // 展示提示弹窗
    showDialog (visible) {
      this.dialogIsShow = visible
    },
  },
  computed: {
    bobi: function () {
      return this.payPrice * 100
    }
  },
}
</script>
<style lang='less' scoped>
.publicPay {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  .payDialog {
    width: 100%;
    // height: 6.4rem;
    box-sizing: border-box;
    padding: 0.4rem 0.4rem 0.6rem 0.4rem;
    background: #ffffff;
    border-radius: 0.2rem 0.2rem 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    // 标题+关闭按钮
    .titles {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 0.3rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #1b1a1f;
      }
      .icon_close {
        width: 0.24rem;
        height: 0.24rem;
        background: url('https://images.zhibo.tv/2020/1109/icon_cancel@2x.png')
          no-repeat;
        background-size: 100%;
      }
    }
    // 支付信息
    .payInfo {
      width: 100%;
      padding: 0.5rem 0 0.3rem 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .payPrice {
        margin-bottom: 0.15rem;
        font-size: 0.54rem;
        font-family: BebasNeue;
        color: #a57359;
        display: flex;
        align-items: baseline;
        span {
          font-size: 0.28rem;
          font-family: BebasNeue;
          color: #a57359;
        }
        .bobi {
          margin-left: 0.1rem;
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #a57359;
        }
      }
      .payName {
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
    // 支付方式
    .payType {
      .typeItem {
        height: 1rem;
        border-bottom: 0.14vw solid #f2f2f2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: normal;
        .type {
          display: flex;
          align-items: center;
          .icons {
            margin-right: 0.1rem;
            img {
              width: 0.44rem;
              height: 0.44rem;
            }
          }
        }
        .select {
          width: 0.34rem;
          height: 0.34rem;
          margin-right: 20px;
          border-radius: 50%;
          border: 0.02rem solid #999999;
        }
        .selected {
          width: 0.36rem;
          height: 0.36rem;
          background: url('https://images.zhibo.tv/2021/0325/icon_selected@2x.png')
            no-repeat;
          background-size: 100%;
          border: none;
        }
      }
      .itemNoBor {
        border-bottom: none;
      }
    }
    // 支付按钮
    .payBtn {
      height: 0.9rem;
      margin-top: 0.54rem;
      background: linear-gradient(145deg, #f5e4d3 0%, #c4a485 100%);
      border-radius: 0.44rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #613f25;
      line-height: normal;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .loading {
    width: 0.88rem;
    height: 0.88rem;
    margin: 0 auto;
    margin-top: 7.2rem;
    img {
      display: block;
      width: 0.88rem;
      height: 0.88rem;
      animation: rotate 2s linear infinite;
    }
    @keyframes rotate {
      0% {
        transform: rotateZ(0deg); /*从0度开始*/
      }
      100% {
        transform: rotateZ(360deg); /*360度结束*/
      }
    }
  }
}
</style>